import { PureComponent } from 'react';
import { Helmet } from 'react-helmet';
import { injectIntl } from 'react-intl';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';

import SideMenu from 'components/SideMenu';
import PlatformSettingsRoutes from 'routes/platformSettingsRoutes';

import { SettingsPageContainer } from 'styles/settings';

import { PLATFORM_SETTINGS_SIDE_MENU_ITEMS } from 'constants/common';

export class PlatformSettings extends PureComponent {
  render() {
    return (
      <SettingsPageContainer>
        <Helmet>
          <title>
            {/* @ts-expect-error TS(2339): Property 'intl' does not exist on type 'Readonly<{... Remove this comment to see the full error message */}
            {this.props.intl.formatMessage({
              id: 'views.Settings.helmetTitle',
            })}
          </title>
          <meta
            name="settings"
            // @ts-expect-error TS(2339): Property 'intl' does not exist on type 'Readonly<{... Remove this comment to see the full error message
            content={this.props.intl.formatMessage({
              id: 'views.Settings.helmetDescription',
            })}
          />
        </Helmet>

        <SideMenu
          title="components.SideMenu.platformSettingsTitle"
          items={PLATFORM_SETTINGS_SIDE_MENU_ITEMS}
          // @ts-expect-error TS(2339): Property 'history' does not exist on type 'Readonl... Remove this comment to see the full error message
          history={this.props.history}
        />
        <PlatformSettingsRoutes />
      </SettingsPageContainer>
    );
  }
}

const mapStateToProps = createStructuredSelector({});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);
// @ts-expect-error TS(2345): Argument of type 'ConnectedComponent<FC<WithIntlPr... Remove this comment to see the full error message
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(PlatformSettings)));
